import { Box, Text } from '@factorialco/deprecated-design-system'
import { Widget } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { Tag as CostCenterTag } from 'modules/cost_centers/components/CostCenterAllocations/Tag'
import { CustomTwoColumnsList } from 'modules/expenses/components/expenses/Detail/_Form/Common/ConfirmationScreen/CustomTwoColumnList'
import { Expensable } from 'modules/expenses/types/Expensable'

import CustomWidgetHeaderButton from './CustomWidgetHeaderButton'

interface CostCentersWidgetProps {
  expensable: Expensable
  editable: boolean
  onEdit: () => void
  showWhenEmpty?: boolean
}

const buildTitle = (allocationType?: string | null) => {
  switch (allocationType) {
    case 'Employee':
      return i18n.t(
        'expenses_v2.confirmation_screen.expense.cost_center_block.employee_cost_center_list'
      )
    default:
      return i18n.t(
        'expenses_v2.confirmation_screen.expense.cost_center_block.expenses_cost_center_list'
      )
  }
}

const CostCentersWidget = ({
  expensable,
  editable,
  onEdit,
  showWhenEmpty,
}: CostCentersWidgetProps) => {
  if (!expensable.costCenterDistribution?.length) {
    if (!showWhenEmpty) return null

    return (
      <Box gap="s16" position="relative">
        <Widget
          header={{
            title: i18n.t('expenses_v2.confirmation_screen.expense.cost_center_block.title'),
          }}
        >
          <Text.Normal size="200" color="grey800">
            {i18n.t('expenses_v2.confirmation_screen.not_assigned_placeholder')}
          </Text.Normal>
        </Widget>
        {editable && (
          <CustomWidgetHeaderButton
            label={i18n.t('expenses_v2.confirmation_screen.confirmation_screen_block_edit_action')}
            onClick={onEdit}
          />
        )}
      </Box>
    )
  }

  const list = [
    {
      title: buildTitle(expensable.costCenterDistribution?.[0]?.allocationReferenceType),
      info: expensable.costCenterDistribution?.[0]?.percentage.toString(),
      customInfoBlock: (
        <Box gap="s8" flexDirection="row" flexWrap="wrap">
          {expensable.costCenterDistribution?.map((distribution, index) => (
            <CostCenterTag
              key={index}
              costCenterName={distribution.costCenter.name}
              percentage={`${(distribution.percentage * 100).toFixed(2)}`}
              index={index}
            />
          ))}
        </Box>
      ),
    },
  ]

  return (
    <Box gap="s16" position="relative">
      <Widget
        header={{
          title: i18n.t('expenses_v2.confirmation_screen.expense.cost_center_block.title'),
        }}
      >
        <CustomTwoColumnsList list={list} />
      </Widget>
      {editable && (
        <CustomWidgetHeaderButton
          label={i18n.t('expenses_v2.confirmation_screen.confirmation_screen_block_edit_action')}
          onClick={onEdit}
        />
      )}
    </Box>
  )
}

export default CostCentersWidget
